import React, { useState, useEffect, Component, useRef, forwardRef } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameAssessment";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//modes
import AsCalculator from "../../components/AsCalculator";
import AsCalculatorFraction from "../../components/AsCalculatorFraction";
import AsCalculatorFractionMixed from "../../components/AsCalculatorFractionMixed";

import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import next from "../../assets/maths_assessments/assets/Next.png";
import back from "../../assets/maths_assessments/assets/Back.png";
import blankbg from "../../assets/maths_assessments/assets/Blank.png";
import marks1 from "../../assets/maths_assessments/assets/marks1.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;
var timer = -1;

//THESE VARIABLES NEED TO BE OUTSIDE THE EXPORT OTHERWISE THEY ARE SET TO DEFAULT EVERY FRAME
var questionNum = 0;
var useranswers = [];

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}


export default function AutumnAr({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const { state: authState } = useAuth();
  const [gameOver, setGameOver] = useState(false);

  const [clearCalc, setClear] = useState(false);

  //this.calculator = React.createRef();


  /*
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });*/
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [status, setStatus] = useState(false);

  //0 = keypad, 
  //1 = multiple choice,
  // 2 = fraction,
  // 3 = int & frac
  //4 = multiple choice 2
  
  //questions section
  var questionsY1Autumn = [];
  questionsY1Autumn.push({ "question" : "2 + 8 = ", "answer" : "10", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "5 + _ = 7", "answer" : "2", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "Add seven and one together", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "One more than 4 is", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "9 – 5 =", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "9 – _ = 3", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "7 - _ = 7", "answer" : "0", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "16 is one less than", "answer" : "17", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "8 + 1 = _ + 5", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsY1Autumn.push({ "question" : "_ - 3 = 6", "answer" : "9", "type": 0, "units" : "", "marks" : 1})

  


  var questionsY2Autumn = [];
  questionsY2Autumn.push({ "question" : "6 + 9 =", "answer" : "15", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "1 more than 12 is", "answer" : "13", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "20 = _ + 15", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "100 - _ = 50", "answer" : "50", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "8 + 7 + 2 =", "answer" : "17", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "56 - 12 = ", "answer" : "44", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "10 – 3 is equal to _ + 6", "answer" : "1", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "53 + 21 = ", "answer" : "74", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "72 + _ = 82", "answer" : "10", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "7 × 2 =", "answer" : "14", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "55 + 16 =", "answer" : "71", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "7 × 5 =", "answer" : "35", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "61 – 14 =", "answer" : "47", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "10p + 2p + 2p + 10p = _p", "answer" : "24", "type": 0, "units" : "", "marks" : 1})
questionsY2Autumn.push({ "question" : "3  x _ = 30", "answer" : "10", "type": 0, "units" : "", "marks" : 1})


  var questionsY3Autumn = [];
  questionsY3Autumn.push({ "question" : "17 + _ = 21", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "599 + 100 = ", "answer" : "699", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "3 x 6 = ", "answer" : "18", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "40 ÷ 5 =", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "8 x _ = 56", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "423 + 164 =", "answer" : "587", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "6 x _ = 0", "answer" : "0", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "Thirty-five more than fifty-eight is", "answer" : "93", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "_ = 100 - 55", "answer" : "45", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "Five hundred and sixty-three subtract forty =", "answer" : "523", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "44 + _ = 34 + 30", "answer" : "20", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "745 – 242 =", "answer" : "503", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "37 + 2 + 63 =", "answer" : "102", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "77 is _ more than 69", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "359 + 274 =", "answer" : "633", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "775 – 182 =", "answer" : "593", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "_ + 333 = 900", "answer" : "567", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "2 × 10 = _ ÷  5", "answer" : "100", "type": 0, "units" : "", "marks" : 1})
questionsY3Autumn.push({ "question" : "822 = 414 + 493 – _", "answer" : "85", "type": 0, "units" : "", "marks" : 1})

  

  var questionsY4Autumn = [];
  questionsY4Autumn.push({ "question" : "346 + 100 =", "answer" : "446", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "10 less than 719 = ", "answer" : "709", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "6 x 11 = ", "answer" : "66", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "36 ÷ 3 = ", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "1,245 + 321 =", "answer" : "1566", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "795 - 542 =", "answer" : "253", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "3 x 5 x 2 =", "answer" : "30", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "8 ÷ _ = 8", "answer" : "1", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "2,384 + 3,087 = ", "answer" : "5471", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "1,300 = _ + 1,288", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "4 x 70 = ", "answer" : "280", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "6,396 - 2,470 = ", "answer" : "3926", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "5,698 rounded to the nearest 10 is ", "answer" : "5700", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "60 ÷ 2 = ", "answer" : "30", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "8,000 - 5,456 = ", "answer" : "2544", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "8 x _ = 64", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "_ ÷  6 = 12", "answer" : "72", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "6,623 + 1,000 - 100 = ", "answer" : "7523", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "50 ÷  5 = _ x 2", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
  questionsY4Autumn.push({ "question" : "5,500 + 766 + 85 =", "answer" : "6351", "type": 0, "units" : "", "marks" : 1})
  

  var questionsY5Autumn = [];
  questionsY5Autumn.push({ "question" : "750 + 349 =", "answer" : "1099", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "578 – 29 =", "answer" : "549", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "45 × _ = 4,500", "answer" : "100", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "56 ÷ 7 =", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "3,533 rounded to the nearest 1,000 is", "answer" : "4000", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "6,468 + 32,042 =", "answer" : "38150", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "3,504 + _ = 5,000", "answer" : "1496", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "48 × 5 =", "answer" : "240", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "Subtract two hundred and six from four hundred and fifty-three", "answer" : "247", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "356 = 456 - _", "answer" : "100", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "1,500 = 3 × _ x 100", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "Forty-seven thousands and nine tens =", "answer" : "47090", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "_ = 199 ÷ 1", "answer" : "199", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "810 ÷ 9 =", "answer" : "90", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "10,000 – 4,845 =", "answer" : "5155", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "8 × _ = 96", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "3^2 = ", "answer" : "9", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "36 ÷ 2 = _ x 3", "answer" : "6", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "6 × 7 × 5 =", "answer" : "210", "type": 0, "units" : "", "marks" : 1})
questionsY5Autumn.push({ "question" : "3,632 + 1,490 = 3,490 + _", "answer" : "1632", "type": 0, "units" : "", "marks" : 1})


  
  var questionsY6Autumn = [];
  questionsY6Autumn.push({ "question" : "4,123 + 100 =", "answer" : "4223", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "63 ÷ _ = 9", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "5 × 4 × 3 × 0 × 3 =", "answer" : "0", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "38,000 – 5,679 =", "answer" : "32321", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "12 × 6 =", "answer" : "72", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "744 ÷ 3 =", "answer" : "248", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "36,042 + 5,936 =", "answer" : "41978", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "5,879,000 ÷ 1,000 =", "answer" : "5879", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "4 × 3 + 4 × 5 =", "answer" : "32", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "2/11 + 5/11 =", "answer" : "7/11", "type": 2, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "565 + 3,649 = 765 + _", "answer" : "3449", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "367 × 15 =", "answer" : "5505", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "48,000 = 12 × _ x 1000", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "_ = 3/13 x 3", "answer" : "9/13", "type": 2, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "5/7 ÷ 2 = ", "answer" : "5/14", "type": 2, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "2&3/5 + 2&7/10 = ", "answer" : "5&3/10", "type": 3, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "3,456 ÷ 16 =", "answer" : "216", "type": 0, "units" : "", "marks" : 1})
questionsY6Autumn.push({ "question" : "1/3 + 1/3 x 1/4 =", "answer" : "5/12", "type": 2, "units" : "", "marks" : 1})



//above is questions section
  
  const [questions, setQuestions] = useState([]);
  console.log(props);

  

  if (status == false){
    currQuestion = [];
    questionNum = 0;
    useranswers = [];
    //check what questions it is, checking year first will check terms later like Autumn etc
    if (props.assessment_type[0] == "1"){
      timer = -1;
      setQuestions(questionsY1Autumn);
    } else if (props.assessment_type[0] == "2"){
      timer = -1;
      setQuestions(questionsY2Autumn);
    } else if (props.assessment_type[0] == "3"){
      timer = 1200;
      setQuestions(questionsY3Autumn);
    } else if (props.assessment_type[0] == "4"){
      timer = 1200;
      setQuestions(questionsY4Autumn);
    } else if (props.assessment_type[0] == "5"){
      timer = 1500;
      setQuestions(questionsY5Autumn);
    } else if (props.assessment_type[0] == "6"){
      timer = 1500;
      setQuestions(questionsY6Autumn);
    }
    setStatus(true);
  }
  console.log(questions);

  if (useranswers.length == 0 && questions.length > 0){
    for (let i = 0; i < questions.length; i++) {
      useranswers.push("");
    }
    console.log("initial Answers array:")
    console.log(useranswers);
  }

  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  console.log("question number: " + questionNum);

  /*TODO: 
  only submit at the end
  may need to scrap a lot of the core code and do it from the ground up
  create a new calculator class just for assessments
  the background image method needs to set it equal to currentquestion number

  */

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    //questionNum++;
    currQuestion = questions[questionNum];
    console.log("Current question");
    console.log(currQuestion);
    console.log("Answers so far:");
    console.log(useranswers);
    setCurrentQuestion(currQuestion);
    setRefresh(!refresh);
    //CheckImage();
  }


  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }
      //Generates a new question
      //newQuestion();

    }
  }

  function MultipleButtons() {
    console.log(currentQuestion);
    return "blank"
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions);
      var sample = questions[questionNum];
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
      //CheckImage();
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status == true) {
      setLoading(false);
    }
  }, [status]);


  function QuestionImage() {
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return blankbg;
    }
    var requireString = "Year"+props.assessment_type[0];
    if (props.assessment_type[3] == "ar"){
      requireString+= "/ARAutumnEnd";
    }else if (props.assessment_type[4]){
      requireString+= "/REAutumnEnd";
    }
    requireString += "/year"+props.assessment_type[0]+"question"+(questionNum+1)+".png";
    return (require("../../assets/maths_assessments/assets/"+requireString))
}

async function setAnswer(value)
  {
    console.log("SET VALUE");
    console.log(value);
    useranswers[questionNum] = value;
    console.log(useranswers);
  }

  function NavigationButtons(){
    if (questionNum != 0 && questionNum != questions.length){
      return (
        <div>
        <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>
        <NavigationButton
        onClick={() => nextQuestion()}>
          <NavigationText>
            Next
          </NavigationText>
        </NavigationButton>
        </div>
      );
    }else if (questionNum < questions.length){
      return (
      <div>
      <NavigationButton
      onClick={() => nextQuestion()}>
        <NavigationText>
          Next
        </NavigationText>
        
      </NavigationButton>
      </div>
      );
    }
    else{
      return (
        <div>
         <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>

        <Button onClick={() => GameOver()} style={{fontSize: "3em", height: "100px", width: "300px", position: "relative", right: "-45%", textAlign: "center", lineHeight: "3.2"}}>
          Submit
        </Button>
        </div>
        );
    }
  }

  function GameOver(){
    setGameOver(true);//go to endscreen
  }

  function ShowMarks(){
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return "";
    }else{
      return marks1;
    }
  }

  function CompareIfCorrect(youranswer, question){
    if (question.type != 1){
      if (question.answer == youranswer){
        return true;
      }else{
        return false;
      }
    }else{
      var correct = question.answer.split("|")[0];
      if (youranswer == correct){
        return true;
      }else{
        return false;
      }
    }
  }

  //I moved this to be called from the practicegameassessment script so it is done on timeout and ending game
  async function SubmitAssessment(){
     var correct = 0;      
    var questionsAnswered = [];
    for (let i = 0; i < questions.length; i++) {
        if (CompareIfCorrect(useranswers[i], questions[i])){
          let data = {
            question: questions[i].question,
            correct: true,
            answer: useranswers[i]
        };
        correct++;
        questionsAnswered.push(data);
        }else{
          let data = {
            question: questions[i].question,
            correct: false,
            answer: useranswers[i]
        };
        questionsAnswered.push(data);
        }
      console.log(JSON.stringify(questionsAnswered));
    }

    var topicstats = [];
    let temptih = {
      topic_key : "mathsassessmentsub",
      game_key : "basic_mathments",
      num_asked : questionsAnswered.length,
      num_correct : correct,
      average_ans_time : "0.0"
    }
    topicstats.push(temptih);

    axios({
        url: `${process.env.REACT_APP_API}/submissions`,
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authState.access_token}`
        },
        data: {
            "homework_id": props.homework.id,
            "topicstats": topicstats,
            "custom": null,
            "platform": "Assessment|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO,
            "game_id": props.homework.galaxy_id,
            "questionsAnswered": JSON.stringify(questionsAnswered)
        }
      }).then((response) => {
        setGameOver(true);//go to endscreen
      })
  }

  function SubmitTimeout(){
    SubmitAssessment();
  }

  
  async function nextQuestion(value)
  {
    questionNum++;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
    //setClear(true);
  }

  function ResetClear(){
    setClear(false);
  }

  async function previousQuestion(value)
  {
    questionNum--;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
  }

  //this returns a table that ticks what questions are done
  function GetEndTable(){
    var html = "";
    html+= "<div>"
    //create a table where it equals amount of questions
    html+= '<table style="margin-top: 20%; width:100%; border-collapse: collapse;">'
    html+= '<tr>'

    for (let i = 0; i < questions.length; i++) {
      console.log(i);
      html+= '<td style="height: 100px, text-align:center; font-size: 4em;">'
      html+= 'Q'+(i+1);
      html+= '</td>';
    }
    html+='</tr><tr>';
    
    useranswers.forEach(element => {
      if (element == ""){
        html+= '<td style="height: 100px; border: 1px solid #9999;"> </td>'
      }else{
        html+= '<td style="height: 100px; background: #FFA500; border: 1px solid #9999;"> </td>'
      }
    });
    html+= "</tr>";
    html+="</table>";
    html+= "</div>";

    return html;
  }

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        gameOver={gameOver}
        SubmitMethod={() => SubmitTimeout()}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionNum={questionNum}
        questionNumMax ={questions.length}
        questionLimit={questionMax}
        onBack={() => props.onBack()}
        loading={loading}
        feedback={feedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
        }}
      >
        <div id="scalinghere">
        <div style={{ backgroundImage: `url(${ShowMarks()}), url(${QuestionImage()})`, position: "relative", top: "-10%", height: "1400px", backgroundSize: "cover" }} >

            <Body>
              
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-end" }}>
                        <div style={{
                          position: "relative",
                          top: "15%",
                          right: "5%",
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {currQuestion.type == 0 &&
                            <AsCalculator
                            onChange={setAnswer}
                            fakeprop={true}
                            resetclear = {ResetClear}
                            currentQuestion={currQuestion}
                            currentAnswer={useranswers[questionNum]}
                            //ref={this.calculator}
                            />
                          }
                          {currQuestion.type == 1 &&
                            MultipleButtons()
                            }
                {currQuestion.type == 2 &&
                 <AsCalculatorFraction
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                 {currQuestion.type == 3 &&
                 <AsCalculatorFractionMixed
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                          
                        </div>
                    </div>
                    
                    <NavigationContainer>
                    {NavigationButtons()}
                    </NavigationContainer>

                  </Container>

                ) : <div>
                  <div dangerouslySetInnerHTML={{ __html: GetEndTable() }}>
                </div><NavigationContainer>{NavigationButtons()}</NavigationContainer></div> }
              </div>
            </Body>
        </div>
        </div>
      </PracticeGame>
    </>
  );
}

const NavigationContainer = styled.div`
  position: fixed;
  top: 70%;
  right: 50%;
`

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationButton = styled.div`
    text-align: center;
    width: 118px;
    height: 144px;
    margin: 5px;
    position: absolute;
    right: -1000px;
    top: 150px
    background-image: url(${next});
    color: #000;
    user-select: none;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationButtonBack = styled.div`
    text-align: center;
    width: 118px;
    height: 144px;
    margin: 5px;
    position: absolute;
    top: 150px;
    right: 1000px
    background-image: url(${back});
    color: #000;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const NavigationText = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
  `;

  const NavigationTextBack = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`